import React from 'react';
import './cta.css'
import { Link } from 'react-router-dom';

const Cta = (props) => {
  if (props.to) {
    return (
      <Link
        to={props.to}
        className="button-container"
        onClick={props.onClick}
      >
        <h2 className="text-button">{props.title}</h2>
      </Link>
    );
  }



    return ( 
        <button className='button-container' onClick={props.onClick}>
            <h2 className='text-button'>{props.title}</h2>
        </button>
     );
}
 
export default Cta;